import styled from 'styled-components';

export const Page = styled.div`
  min-height: 100vh;

  @supports (display: grid) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const Main = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${(props) => props.theme.breakpoints.tablet} {
    align-items: flex-start;
  }
`;
